<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { entries } from "@core/utils/entries.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { customValidationMessages } from "./customValidationMessages.js";

	const {
		value,
		required,
		wrapperClass,
		children,
	}: {
		// The currently selected value of the radio group, used only to determine whether the group
		// is satisfied - the individual radios manage their own selection.
		value?: unknown;
		required?: boolean;
		wrapperClass?: ClassValue;
		children: Snippet;
	} = $props();

	const { tenant } = getGlobalTemplateProps();
	let validityMessage = $state("");

	function validate(input: HTMLInputElement): void {
		const [, message] = entries(customValidationMessages).find(([key]) => input.validity[key]) ?? [];
		validityMessage = message?.(input)[tenant.locale] ?? "";
	}
</script>

<div class={wrapperClass}>
	{@render children()}
	{#if required}
		<div>
			<input
				type="checkbox"
				required
				tabindex="-1"
				aria-hidden="true"
				class="sr-only"
				checked={value !== undefined}
				oninvalid={(event): void => {
					event.preventDefault();
					validate(event.currentTarget);
				}}
			/>
		</div>
		<div class="text-sm text-fcrerror hidden [:has(>:user-invalid)+&:not(:empty)]:flex">
			<Formatted text={validityMessage} />
		</div>
	{/if}
</div>
